import { AssignmentLate, AssignmentReturn, AssignmentTurnedIn } from '@mui/icons-material';
import { Stack } from '@mui/material';
import { CSSProperties, ReactNode, useMemo } from 'react';
import { Tooltip } from 'recharts';

interface EnabledNameFieldProps {
  name: string;
  enabled?: boolean;
  nameTooltip?: ReactNode;
  iconTooltip?: ReactNode;
}

const iconStyle: CSSProperties = {
  height: 16,
  width: 16,
  marginLeft: 8,
  color: 'rgba(153, 153, 153, 1)',
};

export default function EnabledNameField({
  name,
  enabled,
  nameTooltip,
  iconTooltip,
}: EnabledNameFieldProps): React.JSX.Element {
  const nameComponent: ReactNode = useMemo(() => {
    if (nameTooltip && nameTooltip !== '') {
      return (
        <Tooltip title={nameTooltip} placement={'top'}>
          <div>{name}</div>
        </Tooltip>
      );
    }

    return name;
  }, [name, nameTooltip]);

  const icon: ReactNode = useMemo(() => {
    switch (enabled) {
      case true:
        return <AssignmentTurnedIn style={iconStyle} />;
      case false:
        return <AssignmentLate style={iconStyle} />;
      case undefined:
        return <AssignmentReturn style={iconStyle} />;
    }
  }, [enabled]);

  const iconComponent: ReactNode = useMemo(() => {
    if (iconTooltip && iconTooltip !== '') {
      return (
        <Tooltip title={iconTooltip} placment={'top'}>
          {icon}
        </Tooltip>
      );
    }
    return icon;
  }, [icon, iconTooltip]);

  return (
    <Stack direction={'row'}>
      {nameComponent}
      {iconComponent}
    </Stack>
  );
}
